module.exports = __webpack_public_path__ + "media/images/blue-button-4b8800076fa40162f8db8a61d97f6497.png";